import { imagePathResolver, NumberFormats as nf, useClientConfig, useCurrencyFormatter } from '@shared/utils';
import { GameCard } from '..';
import { CAROUSEL_COMPACT_TILE_CLASSNAME } from '../carouselCompactTileClassName';

type GameCardSvgColorsProps = {
  name: string;
  index: number;
  logo: string;
  imgBkg: string;
  provider?: string[];
  jackpot?: number;
  priority?: boolean;
  gameUrl: string;
};

/**
 * GameCardSvgColors component is a wrapper around the GameCard component that renders a game card with a svg background.
 * @param name - The name of the game.
 * @param logo - The logo of the game.
 * @param imgBkg - The background image of the game.
 * @param provider - The provider of the game.
 * @param jackpot - The jackpot of the game.
 * @param index - The index of the game.
 * @param priority - The priority of the game.
 * @returns A GameCard component with a svg background.
 */
function GameCardSvgColors({ name, logo, imgBkg, provider, jackpot, index, priority, gameUrl }: GameCardSvgColorsProps) {
  const { baseImgUrl } = useClientConfig();
  const currencyFormatter = useCurrencyFormatter();
  return (
    <GameCard
      id={name}
      gameProvider={provider?.[0] ?? ''}
      position={index + 1}
      className={`${CAROUSEL_COMPACT_TILE_CLASSNAME} ${index === 0 ? 'carousel-first-item' : ''}`}
      logoImage={imagePathResolver(logo, baseImgUrl, true)}
      backgroundImage={{ background: imagePathResolver(imgBkg, baseImgUrl, true) }}
      gameName={name}
      href={gameUrl}
      jackpotLabelText={jackpot ? currencyFormatter(jackpot).format(nf.WITHOUT_DECIMALS).get() : undefined}
      priority={priority && index <= 3}
      backgroundType="svg"
    />
  );
}

export { GameCardSvgColors };
